"use client";

import { UserButton } from "better-auth-ui";

export function UserMenu() {
  return <UserButton />;
}
